// eslint-disable-next-line import/prefer-default-export
import { v4 as uuidv4 } from 'uuid';

import { Customer } from 'types/Customer';
import { ErplyAttributes } from 'utils/ErplyAttributes';

export const generateCustomPaymentKey = (
  keys: string[],
  type: string,
): string => {
  if (keys.length) {
    const lastKey = keys[keys.length - 1];
    return type.concat(`${Number(lastKey.replace(type, '')) + 1}`);
  }
  return `${type}1`;
};

export const getCustomerAndContactFieldsForSaveSalesDocument = (
  customer: Customer,
) => {
  const { customerID, companyID } = customer;
  if (companyID) {
    return { customerID: companyID, contactID: customerID };
  }
  return { customerID };
};

type GeneratedAttributes = {
  originalPaymentID: number;
  hostReferenceID: string;
  originalTip?: number;
  isTapToPayPayment?: boolean;
};
export function getGeneratedAttributes(payment) {
  const withGeneratedAttributes: GeneratedAttributes = {
    originalPaymentID: Number(payment.paymentID),
    hostReferenceID: uuidv4(),
  };
  const attributes = new ErplyAttributes(payment.attributes);
  const wasMadeWithTapToPay = Boolean(attributes.get('isTapToPayPayment'));
  const originalTip = attributes.get('tipAmount');
  if (wasMadeWithTapToPay) {
    withGeneratedAttributes.isTapToPayPayment = true;
  }
  if (originalTip) {
    withGeneratedAttributes.originalTip = originalTip;
  }
  return withGeneratedAttributes;
}
